import React, { Fragment } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import ServiceConfiguration from "../../Feature/bussiness/operationalSetting/serviceConfiguration/index";
import OrderManagement from "../../Feature/bussiness/operationalSetting/orderManagement/index";
import PricingTiers from "../../Feature/bussiness/operationalSetting/pricingTiers/index";
import NotificationPanel from "../../Feature/notification/index";
import ServiceAreaManagement from "../../Feature/bussiness/operationalSetting/serviceAreaManagement/index";
import OperationalSetting from "../../Feature/bussiness/operationalSetting/storeOperation/index";
import FeedbackManagement from "../../Feature/bussiness/feedbackManagement";
import Dashboard from "../../Feature/bussiness/dashboard";
import PromotionsAndMarketing from "../../Feature/bussiness/promotionsAndMarketing";
import CreateCampaign from "../../Feature/bussiness/promotionsAndMarketing/createCampign";
import InventoryManagement from "../../Feature/bussiness/inventoryManagement";
import Profile from "../../Feature/bussiness/Profile";
import InDevelopment from "../../Feature/development";
import RBACManagementBusiness from "../../Feature/bussiness/rbacManagementBussiness";
import { Navigate } from "react-router-dom";
import Notification from "../../Feature/bussiness/notification";
import CustomerManagement from "../../Feature/bussiness/operationalSetting/customerManagement/index";


const ProtectedRoute = ({ children, resource, action = "view" }) => {
  const permissions = useSelector((state) => state.counter.permissions);
  const rolePermissions = permissions?.[0]?.permissions || [];

  const hasPermission = () => {
    if (!resource) return true;

    const resources = Array.isArray(resource) ? resource : [resource];

    return rolePermissions.some(
      (permission) =>
        resources.some(
          (res) =>
            permission.resource?.toLowerCase() === res.toLowerCase()
        ) && permission.action?.includes(action)
    );
  };

  return hasPermission() ? children : <Navigate to="/" replace />;
};

const BusinessAuth = () => {


  const routes = [
    { path: "/service-configuration", element: <ServiceConfiguration />, resource: "Service Configuration" },
    { path: "/order-management", element: <OrderManagement />, resource: "Order Management" },
    { path: "/customer-management", element: <CustomerManagement />, resource: "Customer Management" },
    { path: "/pricing-tiers", element: <PricingTiers />, resource: "Pricing Tiers" },
    { path: "/service-area", element: <ServiceAreaManagement />, resource: "Service Area" },
    { path: "/operational-setting", element: <OperationalSetting Setting />,  resource: ["Operational Setting", "Store Operations"], },
    { path: "/feedback", element: <FeedbackManagement />, resource: "Feedback Management" },
    { path: "/dashboard", element: <Dashboard />, resource: "Analytics and report" },
    { path: "/promotions&marketing", element: <PromotionsAndMarketing />, resource: "Promotions & Marketing" },
    { path: "/promotions&marketing/create", element: <CreateCampaign />, resource: "Promotions & Marketing" },
    { path: "/inventory", element: <InventoryManagement />, resource: "Inventory Management" },
    { path: "/business/profile", element: <Profile />, resource: null },
    { path: "/business/notification", element: <Notification />, resource: null },
    { path: "/business/rbac-management", element: <RBACManagementBusiness />, resource: "RBAC Management" },

  ];

  return (
     <Routes>
        {routes.map(({ path, element, resource }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute resource={resource}>
                {element}
              </ProtectedRoute>
            }
          />
        ))}
      </Routes>
  );
};

export default BusinessAuth;


